import React, {Component} from 'react';
import {Checkbox} from '../../../commons/Inputs';
import { Link } from 'react-router';

let moment = window.moment;
let $ = window.jQuery;

export default class PatientList extends Component {

	state = {
		data : [],
		isSaving : false
	}

	handleErrorImage = (e) => {
        e.target.src = '/images/generic_profile_pic.png';
    }

	handleOnCheck = (e) => {
		let data = this.state.data;
		this.props.onCheckBox(e,data);
	}

	handlerDeletePatient = (e) => {
		$('#deletePatientModal').modal('show');
		let data = this.state.data;
		this.props.singleDeletePatient(data);
	}

	handleClickSendSMS = (e) => {
		this.props.openSMSDialog(this.state.data);
	}

	componentDidMount() {
		this.setState({data : this.props.data});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({data : nextProps.data});
	}

	render() {
		let datas = this.state.data;

		const last_practitioner = datas.patient_visit_latest ? 'Dr. ' + datas.patient_visit_latest.practitioner.user.firstname.charAt(0) + '. ' + datas.patient_visit_latest.practitioner.user.lastname : 'N/A';
		const last_facility = datas.patient_visit_latest ? datas.patient_visit_latest.facility.name : 'N/A';
		const last_visit = datas.patient_visit_latest ? moment(datas.patient_visit_latest.created_at).format('MMMM DD, YYYY') : moment(datas.entryDate).format('MMMM DD, YYYY')

		return(
			/*<img className="img-circle img-responsive" src={datas.media_id} onError={this.handleErrorImage} style={{border: '2px solid #ECEFF2'}} />*/
			<div className="col-md-4">
				<div className="portlet light portlet-fit">
					<div className="portlet-body flip-scroll" style={{padding : '18px 20px 20px'}}>
						<div className="row">
							<Link to={'patients/' + datas.id}>
								<div className="col-md-4 col-xs-5">
									<div className="profilePicList" style={{backgroundImage : 'url('+ (datas.media_id ? datas.media_id : "/images/generic_profile_pic.png") +')',backgroundRepeat: 'no-repeat',backgroundSize: 'cover',backgroundPosition: '50% 50%',height: '93px',width: '93px',border: '2px solid #ECEFF2',borderRadius: '50%'}}></div>
								</div>
								<div className="col-md-6 col-xs-5" style={{marginTop: '25px'}}>
									<div style={{lineHeight: '20px'}}>
										<div><strong>{datas.name}</strong></div>
										<div>{datas.id}</div>
									</div>
								</div>
							</Link>
								<div className="col-md-2 col-xs-2 text-right">
									<Checkbox name="patientbox" id="patientList" label="" value={datas.id ? datas.id : 0} key={datas.id} index={datas.id} onchange={this.handleOnCheck} checkedItems={[]} />
								</div>
						</div>
						<hr style={{margin : '15px 0'}}/>
						<div className="row">
							<div className="col-md-6 col-xs-6">
								<div className="text-muted" style={{fontSize : '10px', marginBottom : '3px'}}>Dentist</div>
								<div className="text-muted" style={{fontSize : '12px',textTransform : 'capitalize'}}><b>{last_practitioner}</b></div>
							</div>
							<div className="col-md-6 col-xs-6">
								<div className="text-muted" style={{fontSize : '10px', marginBottom : '3px'}}>Branch</div>
								<div className="text-muted" style={{fontSize : '12px'}}><b>{last_facility}</b></div>
							</div>
						</div>
						<hr style={{margin : '15px 0'}}/>
						<div className="row">
							<div className="col-md-6 col-xs-6">
								<div className="text-muted" style={{fontSize : '10px', marginBottom : '3px'}}>Entry Date</div>
								<div className="text-muted" style={{fontSize : '12px'}}><b>{moment(datas.entryDate).format('MMMM DD, YYYY')}</b></div>
							</div>
							<div className="col-md-6 col-xs-6">
								<div className="text-muted" style={{fontSize : '10px', marginBottom : '3px'}}>Last Visit</div>
								<div className="text-muted" style={{fontSize : '12px'}}><b>{last_visit}</b></div>
							</div>
						</div>
						<hr style={{margin : '15px 0'}}/>
						<div className="row">
							<div className="col-md-4 col-xs-6">
								<button type="button" className="btn btn-primary" onClick={this.handleClickSendSMS}>Send Message</button>
							</div>
							<div className="col-md-3 col-xs-6 col-md-offset-2 text-right">
								<a href={'patients/' + datas.id} style={{verticalAlign: '-webkit-baseline-middle'}}>Edit</a>
							</div>
							<div className="col-md-3 text-right">
								<a onClick={this.handlerDeletePatient} style={{verticalAlign: '-webkit-baseline-middle', color : 'red'}}>Delete</a>
							</div>
						</div>
					</div>
                </div>

                

			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Patient_list/PatientList.js
 **/